export function ScaledStill({ Component, w, h, width = 280, spaStyle }) {
  const scale = width / w;
  return (
    <div style={{ width, height: h * scale, overflow: "hidden", borderRadius: 18, boxShadow: "0 24px 50px -30px rgba(31,31,31,.45)", background: "#fff" }}>
      <div style={{ width: w, height: h, transform: `scale(${scale})`, transformOrigin: "top left" }}>
        <Component spaStyle={spaStyle} />
      </div>
    </div>
  );
}

export function SectionHeader({ n, title, kicker, id }) {
  return (
    <div id={id} className="fade-up" style={{ display: "grid", gridTemplateColumns: "120px 1fr", gap: 32, alignItems: "end", paddingTop: 96, scrollMarginTop: 40 }}>
      <span className="serif" style={{ fontSize: 120, lineHeight: .8, fontWeight: 400, color: "var(--burgundy)" }}>{n}</span>
      <div>
        <div className="eyebrow">{kicker}</div>
        <h2 className="serif" style={{ fontSize: 48, fontWeight: 500, margin: "8px 0 0", lineHeight: 1.05 }}>{title}</h2>
      </div>
    </div>
  );
}

export function StatusPill({ status }) {
  const map = {
    idle: ["Not generated", "var(--ink-06)", "var(--ink-60)"],
    generating: ["Generating…", "var(--lilac)", "#4B3A7A"],
    ready: ["Ready", "var(--mint)", "#1F5C3A"],
  };
  const isErr = status?.startsWith("error");
  const [label, bg, fg] = isErr ? ["Failed", "var(--blush)", "var(--burgundy)"] : map[status] || map.idle;
  return (
    <span data-testid="status-pill" title={isErr ? status : undefined} style={{ display: "inline-flex", alignItems: "center", gap: 8, background: bg, color: fg, borderRadius: 999, padding: "5px 12px", fontSize: 12, fontWeight: 700 }}>
      {status === "generating" && <span className="pulse-dot" style={{ width: 7, height: 7, borderRadius: "50%", background: fg }} />}
      {label}
    </span>
  );
}
